<!-- Start Breadcrumbs -->
<app-breadcrumbs
	title="E Charts"
	[breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Line Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="LineChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Stacked Line Chart</h4>
			</div>
			<div class="card-body">
				<div
					echarts
					[options]="StackedLineChart"
					class="demo-chart"
				></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Area Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="AreaChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Stacked Area Chart</h4>
			</div>
			<div class="card-body">
				<div
					echarts
					[options]="StackedAreaChart"
					class="demo-chart"
				></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Step Line</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="StepLineChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Line Y Category</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="LineYChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Basic Bar</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="BasicBarChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Horizontal Bar</h4>
			</div>
			<div class="card-body">
				<div
					echarts
					[options]="HorizontalBarChart"
					class="demo-chart"
				></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Stacked Horizontal Bar</h4>
			</div>
			<div class="card-body">
				<div
					echarts
					[options]="StackedHorizontalBarChart"
					class="demo-chart"
				></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Pie Charts</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="PieChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Doughnut Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="DoughnutChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Candlestick Chart</h4>
			</div>
			<div class="card-body">
				<div
					echarts
					[options]="CandleStickChart"
					class="demo-chart"
				></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Graph Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="GraphChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Treemap Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="TreemapChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Sunburst Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="sunburstChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Parallel Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="ParallelChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Sankey Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="SankeyChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Funnel Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="FunnelChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Gauge Chart</h4>
			</div>
			<div class="card-body">
				<div echarts [options]="GaugeChart" class="demo-chart"></div>
			</div>
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->
